import script from "./AiInitSetupSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./AiInitSetupSuccess.vue?vue&type=script&setup=true&lang=js"

import "./AiInitSetupSuccess.vue?vue&type=style&index=0&id=19b37d49&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b37d49"]])

export default __exports__